




import Vue from 'vue';
import CheckIcon from '../../../assets/img/check.svg';
export default Vue.extend({
    components: {
        CheckIcon,
    },
    props: {
        shadow: {
            type: Boolean,
            default: false,
        },
    },
});
